import React from "react"
import ReactDOM from "react-dom"
// 放到苍穹页面直接使用
import {createStore} from "redux"
import {Provider} from "react-redux"
import {isProduction} from "../src/function/base/checkProduct"
import View from "../src/components/index"
import {processData} from "../src/function/base/processData"
import {reducer} from "../src/reducer/reducer"
import {setModel} from "../src/action/global"
;(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            if (!window.scrollTo) {
                window.scrollTo = function (x, y) {
                    window.scrollLeft = x
                    window.scrollTop = y
                }
            }

            if (!document.body.scrollTo) {
                Element.prototype.scrollTo = function (x, y) {
                    this.scrollLeft = x
                    this.scrollTop = y
                }
            }
            this.passageway = new Date().getTime()
            this.store = createStore(reducer)
            this.store.dispatch(setModel(this.model))
            isProduction ? console.log("-----init", this.model.style, props) : null
            this.model.invokeAsync("init", "init")
            KDApi.loadFile("./main.css", this.model, () => {
                ReactDOM.render(
                    <Provider store={this.store}>
                        <View />
                    </Provider>,
                    this.model.dom
                )
            })
        },
        update: function (props) {
            if (props.data) {
                processData(props.data, this.store.dispatch)
            }
            isProduction ? console.log("-----update", this.model, props) : null
        },
        destoryed: function () {
            this.store.dispatch({type: "TDAInit", payload: "TDAInit"})
            ReactDOM.unmountComponentAtNode(this.model.dom)
            isProduction ? console.log("-----destoryed", this.model) : null
        },
    }

    // 注册自定义组件
    KDApi.register("ai-cvp-ocr-tda", MyComponent)
    // KDApi.register("ai-cvp-ocr-distinguish", MyComponent)
})(window.KDApi)

console.log("TDA: <<<<<<<<<<<<<<<<<<<<<<<SS_TIME_STAMP>>>>>>>>>>>>>>>>>>>>>")
